import { useEffect, useState } from "react";
import { getPlazosMontos } from "../services/apiService";
import { generarPlazosValidos } from "../utils/validation";

export const usePlazos = (monto, configuration) => {
    const [plazos, setPlazos] = useState([]);
    const [mensaje, setMensaje] = useState("");
    const [esValido, setEsValido] = useState(false);
    const [limites, setLimites] = useState(null);

    useEffect(() => {
        if (!monto || !configuration) return;

        const load = async () => {
            try {
                const lista = await getPlazosMontos(configuration);
                if (!Array.isArray(lista)) {
                    return;
                }
                const montoEntero = parseInt(String(monto).replace(/\D/g, ""));
                const valoresMinimos = lista.map(r => r.valorMinimo);
                const valoresMaximos = lista.map(r => r.valorMximo);
                const minPermitido = Math.min(...valoresMinimos);
                const maxPermitido = Math.max(...valoresMaximos);

                setLimites({ min: minPermitido, max: maxPermitido });
                if (montoEntero < minPermitido) {
                    const mensajeMin = `El monto mínimo permitido es ${minPermitido.toLocaleString('es-CO')}`;
                    setMensaje(mensajeMin);
                    setEsValido(false);
                    setPlazos([]);
                    return;
                }

                if (montoEntero > maxPermitido) {
                    const mensajeMax = `El monto máximo permitido es ${maxPermitido.toLocaleString('es-CO')}`;
                    setMensaje(mensajeMax);
                    setEsValido(false);
                    setPlazos([]);
                    return;
                }

                const itemValido = lista.find(
                    r => montoEntero >= r.valorMinimo && montoEntero <= r.valorMximo
                );

                if (itemValido) {
                    const plazosFiltrados = generarPlazosValidos(
                        itemValido.plazoMinimo,
                        itemValido.plazoMaximo
                    );
                    setPlazos(plazosFiltrados);
                    setMensaje("");
                    setEsValido(true);
                } else {
                    const mensajeNoEncontrado = "No se encontraron plazos para el monto ingresado.";
                    setMensaje(mensajeNoEncontrado);
                    setEsValido(false);
                    setPlazos([]);
                }

            } catch (error) {
                setMensaje("Error al validar el monto.");
                setEsValido(false);
                setPlazos([]);
            }
        };

        load();
    }, [monto, configuration]);

    return { plazos, mensaje, esValido, limites };
};
